module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-component",
    class: {
      'box': _vm.look == 'boxed'
    },
    attrs: {
      "data-look": _vm.look
    }
  }, [_c('div', {
    class: {
      'header': _vm.look == 'boxed'
    }
  }, [_c('div', {
    staticClass: "tab-links"
  }, _vm._l((_vm.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-link",
      class: {
        'active': tab.isActive
      },
      domProps: {
        "innerHTML": _vm._s(tab.header)
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(i)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    class: {
      'content': _vm.look == 'boxed'
    }
  }, [_c('div', {
    staticClass: "tab-area",
    attrs: {
      "data-look": _vm.look
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-208eeed4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 585
// module chunks = 1